import { useState } from 'react';

/**
 * Floating data-error indicator.
 * Renders a small fixed badge in the bottom-left corner.
 * Clicking it opens a panel listing all error messages.
 */
export default function DataErrorBadge({ errors = [] }) {
  const [open, setOpen] = useState(false);

  if (!errors.length) return null;

  return (
    <div className="data-error-badge-wrap">
      <button
        className="data-error-badge"
        onClick={() => setOpen(v => !v)}
        aria-label={`${errors.length} data source issue${errors.length > 1 ? 's' : ''} — click for details`}
        title="Data source issues"
      >
        ⚠ {errors.length} data issue{errors.length > 1 ? 's' : ''}
      </button>

      {open && (
        <div className="data-error-panel" role="dialog" aria-label="Data source issues">
          <div className="data-error-panel-header">
            <span>Data source issues</span>
            <button
              className="data-error-panel-close"
              onClick={() => setOpen(false)}
              aria-label="Close"
            >×</button>
          </div>
          <ul className="data-error-panel-list">
            {errors.map((msg, i) => (
              <li key={i}>{msg}</li>
            ))}
          </ul>
          <p className="data-error-panel-hint">
            Check your network connection and API keys, then refresh the page.
          </p>
        </div>
      )}
    </div>
  );
}
